import { render, staticRenderFns } from "./static-question-renderer.vue?vue&type=template&id=d6b543fc&scoped=true"
import script from "./static-question-renderer.vue?vue&type=script&lang=js"
export * from "./static-question-renderer.vue?vue&type=script&lang=js"
import style0 from "./static-question-renderer.vue?vue&type=style&index=0&id=d6b543fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b543fc",
  null
  
)

export default component.exports